import './ramda-extension-type.d.ts';
export { toUpperFirst } from 'ramda-extension';
